import React from 'react';
import { ArrowUpDown, ArrowDown, ArrowUp } from 'lucide-react';
import type { ForumSortOption, SortDirection } from '../../hooks/useForum';

interface ForumSortProps {
  sortBy: ForumSortOption;
  sortDirection: SortDirection;
  onSortChange: (sort: ForumSortOption) => void;
  onDirectionChange: (direction: SortDirection) => void;
}

const ForumSort: React.FC<ForumSortProps> = ({
  sortBy,
  sortDirection,
  onSortChange,
  onDirectionChange
}) => {
  return (
    <div className="flex items-center gap-2">
      <select
        value={sortBy}
        onChange={(e) => onSortChange(e.target.value as ForumSortOption)}
        className="bg-background border border-gray-800 rounded-lg text-content-primary px-3 py-2 focus:ring-2 focus:ring-brand focus:border-brand transition-colors"
      >
        <option value="recent">Most Recent</option>
        <option value="comments">Most Discussed</option>
      </select>

      <button
        onClick={() => onDirectionChange(sortDirection === 'asc' ? 'desc' : 'asc')}
        className="p-2 bg-background border border-gray-800 rounded-lg text-content-secondary hover:text-brand hover:border-brand transition-colors"
        title={sortDirection === 'asc' ? 'Sort Ascending' : 'Sort Descending'}
      >
        {sortDirection === 'asc' ? (
          <ArrowUp className="w-4 h-4" />
        ) : (
          <ArrowDown className="w-4 h-4" />
        )}
      </button>
    </div>
  );
};

export default ForumSort;